import 'slick-carousel';

export default ($container) => {
    $('.js-recommend-slider', $container).slick({
        rows:         0,
        slidesToShow: 4,
        responsive:   [
            {
                breakpoint: 1200,
                settings:   {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 992,
                settings:   {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 768,
                settings:   {
                    arrows:       false,
                    slidesToShow: 1,
                },
            },
        ],
    });
};
